import {
  petAppointmentsFailure,
  petAppointmentsRequest,
  petAppointmentsSuccess,
} from 'store/reducers/petInformation';
import {
  appointmentsFailure,
  appointmentsRequest,
  appointmentsSuccess,
} from 'store/reducers/providerAppointments';

import { fetchData } from './fetchData';

export const loadProviderAppointments = () => (dispatch, getState) => {
  const { provider } = getState();
  const luid = provider.locations?.[0]?.uuid;

  return fetchData({
    endpoint: `provider/location/${luid}/appointments`,
    actions: [appointmentsRequest, appointmentsSuccess, appointmentsFailure],
  })(dispatch, getState);
};

export const loadGroomerAppointments = () => (dispatch, getState) => {
  const { provider, ui } = getState();
  const luid = provider.locations?.[0]?.uuid;
  const groomerId = ui.selectedGroomer.uuid;

  return fetchData({
    endpoint: `location/${luid}/user/${groomerId}/appointments`,
    actions: [appointmentsRequest, appointmentsSuccess, appointmentsFailure],
  })(dispatch, getState);
};

export const acceptAppointment = (appointmentId) => (dispatch, getState) =>
  fetchData({
    endpoint: `appointment/${appointmentId}/provider/accept`,
    actions: [null, null, null],
    httpMethod: 'post',
  })(dispatch, getState);

export const arrivedAppointment = (appointmentId) => (dispatch, getState) =>
  fetchData({
    endpoint: `appointment/${appointmentId}/provider/arrived`,
    actions: [null, null, null],
    httpMethod: 'post',
  })(dispatch, getState);

export const declineAppointment = (appointmentId) => (dispatch, getState) =>
  fetchData({
    endpoint: `appointment/${appointmentId}/provider/decline`,
    actions: [null, null, null],
    httpMethod: 'post',
  })(dispatch, getState);

export const rescheduleAppointment =
  ({ appointmentId, body }) =>
  (dispatch, getState) =>
    fetchData({
      endpoint: `appointment/${appointmentId}/provider/suggest`,
      actions: [null, null, null],
      httpMethod: 'post',
      body,
    })(dispatch, getState);

export const noShowAppointment = (appointmentId) => (dispatch, getState) =>
  fetchData({
    endpoint: `appointment/${appointmentId}/provider/no-show`,
    actions: [null, null, null],
    httpMethod: 'post',
  })(dispatch, getState);

export const cancelAppointment = (appointmentId) => (dispatch, getState) =>
  fetchData({
    endpoint: `appointment/${appointmentId}/provider/cancel`,
    actions: [null, null, null],
    httpMethod: 'post',
  })(dispatch, getState);

export const patchAppointment = (appointmentId, body) => (dispatch, getState) =>
  fetchData({
    endpoint: `appointment/${appointmentId}/provider`,
    actions: [null, null, null],
    httpMethod: 'patch',
    body,
  })(dispatch, getState);

export const createAppointment =
  ({
    animalUuid,
    locationUuid,
    locationUserUuid,
    serviceUuid,
    userUuid,
    note,
    dateStart,
  }) =>
  (dispatch, getState) => {
    const uuidObject = {
      animal: animalUuid,
      location: locationUuid,
      location_user: locationUserUuid,
      service: serviceUuid,
      user: userUuid,
    };

    return fetchData({
      endpoint: 'appointment/provider',
      actions: [null, null, null],
      httpMethod: 'post',
      body: {
        uuid: uuidObject,
        dateStart: `${dateStart}.000Z`,
        note,
      },
    })(dispatch, getState);
  };

export const loadAppointmentsRequests =
  (animalUuid) => (dispatch, getState) => {
    const luid = getState().provider.locations[0].uuid;
    return fetchData({
      endpoint: `provider/location/${luid}/animal/${animalUuid}/appointments`,
      actions: [
        petAppointmentsRequest,
        petAppointmentsSuccess,
        petAppointmentsFailure,
      ],
    })(dispatch, getState);
  };

export const loadAppointment =
  ({ apuid, actions }) =>
  (dispatch, getState) =>
    fetchData({
      endpoint: `appointment/${apuid}/provider`,
      actions: actions || [null, null, null],
    })(dispatch, getState);

export const invoiceSummary =
  ({ apuid, body }) =>
  (dispatch, getState) =>
    fetchData({
      endpoint: `appointment/${apuid}/provider/summary`,
      actions: [null, null, null],
      httpMethod: 'post',
      body,
    })(dispatch, getState);

export const completeAppointment =
  ({ apuid, body }) =>
  (dispatch, getState) =>
    fetchData({
      endpoint: `appointment/${apuid}/provider/completed`,
      actions: [null, null, null],
      httpMethod: 'post',
      body,
    })(dispatch, getState);

export const loadAvailableSlots =
  ({ dateStart, dateEnd, groomer, luid }, actions) =>
  (dispatch, getState) => {
    const dateQuery = `?date_start=${dateStart}&date_end=${dateEnd}`;
    const userQuery = `&user_uuid=${groomer}`;

    const queries = `${dateQuery}${userQuery}`;

    return fetchData({
      endpoint: `location/${luid}/availability/consumer${queries}`,
      actions: actions || [null, null, null],
      httpMethod: 'get',
    })(dispatch, getState);
  };

export const loadClients = (search) => (dispatch, getState) => {
  const { provider } = getState();
  const luid = provider.locations?.[0]?.uuid;

  return fetchData({
    endpoint: `location/${luid}/consumers?q=${search}`,
    actions: [null, null, null],
  })(dispatch, getState);
};

export const loadClientPaymentData =
  ({ uuid }) =>
  (dispatch, getState) => {
    const { provider } = getState();
    const luid = provider.locations?.[0]?.uuid;

    return fetchData({
      endpoint: `location/${luid}/consumers/${uuid}`,
      actions: [null, null, null],
    })(dispatch, getState);
  };

export const loadInvoiceCheck = (service) => (dispatch, getState) => {
  const { provider } = getState();
  const luid = provider.locations?.[0]?.uuid;

  return fetchData({
    endpoint: 'appointment/invoice/check',
    actions: [null, null, null],
    httpMethod: 'post',
    body: {
      service,
      location: luid,
    },
  })(dispatch, getState);
};
